import { WebhookProps } from "@/lib/types";
import { fetcher } from "@panda0/panda0-utils";
import useSWR from "swr";
import useWorkspace from "./use-workspace";

export default function useWebhooks() {
  const { id, plan } = useWorkspace();

  const {
    data: webhooks,
    isValidating,
    isLoading,
  } = useSWR<WebhookProps[]>(
    plan &&
    !["KICKSTART", "PRO"].includes(plan) &&
    `/api/v1/webhooks?workspaceId=${id}`,
    fetcher,
    {
      dedupingInterval: 60000,
    },
  );

  return {
    webhooks,
    isLoading,
    isValidating,
  };
}
